<script>

export default {
  data() {
      return {
          email: '',
          password: '',
          error: '',
          loading: false,
      };
  },
  methods: {
    fetchToken() {
      return this.$api.post('login/', {
          username: this.email,
          password: this.password
        }).then(response => {
          this.error = '';
          return response
        }).catch(error => {
          console.error('Error:', error);
          this.error = 'Problem bei der Anmeldung.';
          this.loading = false;
        })
    },
    login() {
      if (this.loading) return
      this.loading = true
      let me = this
      this.fetchToken().then(response => {
        if (!response) return
        me.$storage.performLogin(response.data)
        me.$storage.askForPushNotificationPermission()

        let next = me.$route.query.next || '/user-profile'
        me.$storage.fetchUser().then(() => {
          me.$router.push(next)
        }).catch(() => {
          me.$router.push(next)
        })
      })
    },
    pwResetUrl() {
      return '/accounts/password/reset/'
    },
    signupUrl() {
      return '/accounts/signup/'
    },
  },
}
</script>

<template>
  <div>
  <nav class="nav navbar">
    <div class="nav-item">
      <router-link to="/" class="nav-link"><i class="fas fa-home float-end"></i></router-link>
    </div>
  </nav>
  <div class="container d-flex flex-column align-items-center">
    <img src="/media/logo.png" class="img-fluid my-5" alt="ZP Logo" style="max-width:6rem">
    <div class="card" style="width:18rem">
      <div class="card-body">
        <h2 class="card-title text-center">Login</h2>
        <div v-if="error" class="alert alert-danger">{{ error }}</div>
        <form @submit.prevent="login">
          <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" class="form-control" v-model="email" :disabled="loading">
          </div>
          <div class="form-group">
            <label for="password">Password:</label>
            <input type="password" id="password" class="form-control" v-model="password" :disabled="loading">
          </div>
          <div class="form-row justify-content-center">
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ loading ? 'Anmelden...' : 'Login' }}
            </button>
          </div>
        </form>
      </div>
    </div>
      <br>
      <p><a :href="pwResetUrl()" target="_blank">Passwort vergessen?</a></p>
      <p><a :href="signupUrl()" target="_blank">Noch kein Login/Konto?</a></p>
      <hr class="w-100">
      <p class="text-muted small"><router-link to="/about">Über diese App</router-link></p>
  </div>
  </div>
</template>
